export const copyToClipboard = async (text) => {
  try {
    console.log("Attempting to copy text:", text);
    await navigator.clipboard.writeText(text);
    console.log("Successfully copied to clipboard");
    return Promise.resolve();
  } catch (err) {
    console.error("Clipboard error:", err.message);
    return Promise.reject(err);
  }
};
